import React, { Fragment } from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';

const Footer = props => {
	return (
		<Fragment>
			<Typography className="text-grey">
                若有任何問題，請與 CellWine 聯絡，可致電 (02)2553-2771（周一～週五, 9:30~ 18:30）
            </Typography>
            <Typography className="text-grey">
                或是寫信至
                <Typography color="primary" style={{display: 'inline-block'}}>
                    <Link href="mailto:Service@cell.wine">Service@cell.wine</Link>
                </Typography>
            ，我們會盡快為您服務，謝謝！
            </Typography>
		</Fragment>
	)
}

export default Footer
